import { ReactNode } from 'react';
import { Modal } from './Modal';

interface ConfirmDialogProps {
    title: string;
    children: ReactNode;
    confirmLabel: string;
    cancelLabel?: string;
    destructive?: boolean;
    loading?: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

export function ConfirmDialog({
    title,
    children,
    confirmLabel,
    cancelLabel = 'Cancelar',
    destructive = true,
    loading = false,
    onConfirm,
    onClose,
}: ConfirmDialogProps) {
    return (
        <Modal
            title={title}
            onClose={() => {
                if (!loading) onClose();
            }}
            desktopClassName="sm:!max-w-md"
        >
            <div className="text-sm text-base-content/70">{children}</div>
            <div className="mt-5 flex justify-end gap-2">
                <button type="button" className="btn btn-ghost" onClick={onClose} disabled={loading}>
                    {cancelLabel}
                </button>
                <button
                    type="button"
                    className={`btn ${destructive ? 'btn-error' : 'btn-primary'}`}
                    onClick={onConfirm}
                    disabled={loading}
                >
                    {loading && <span className="loading loading-spinner loading-sm"></span>}
                    {confirmLabel}
                </button>
            </div>
        </Modal>
    );
}
